import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cn } from '../utils/cn.ts'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'destructive' | 'ghost'
  loading?: boolean
  fullWidth?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    { variant = 'primary', loading = false, fullWidth, className, children, onClick, ...rest },
    ref,
  ) {
    const isGhost = variant === 'ghost'
    const resolvedFullWidth = fullWidth ?? !isGhost

    return (
      <button
        ref={ref}
        className={cn(
          'btn',
          `btn-${variant}`,
          resolvedFullWidth && 'btn-full-width',
          loading && 'btn-loading',
          className,
        )}
        aria-busy={loading || undefined}
        onClick={loading ? undefined : onClick}
        {...rest}
      >
        {loading ? <span className="btn-dots">···</span> : children}
      </button>
    )
  },
)
